<template>
          <v-dialog v-model="show" max-width="580">
            <v-card>
                <v-card-title class="headline primary--text rundown-dialog-head">
                {{$t('PURCHASE_POPUP_TITLE')}}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>


        <v-container> 

                    <v-row>
                     <div  style="
                            text-align: left;
                            margin-left:5px;
                            float: left;"> 
                            <ul>
                            <li v-for="(item, itemIndex) in features" :key="itemIndex">{{item}}</li>
                            </ul> 
                            </div>    
                    </v-row> 
                    <v-row  class="my-3 mx-auto">
                        <v-spacer></v-spacer>
                        <v-col cols="8" sm="6" style="border-radius: 4px 0px 0px 4px; background-color: #FFF3CD;  color: #856404;">{{storeProduct.title}}</v-col>
                        <v-col cols="4" sm="2" style="border-radius: 0px 4px 4px 0px; background-color: #FFF3CD;  color: #856404; text-align: right;" v-if="storeProduct.price" >{{storeProduct.price}} / {{storeProduct.billingPeriodUnit}}</v-col>
                        <v-spacer></v-spacer>
                    </v-row>

                     <v-row>
                        <v-col @click="refreshPurchases" cols="12" style="text-decoration:underline;">{{$t('PURCHASE_POPUP_REFRESH_PURCHASES')}}</v-col>
                    </v-row>
                              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
                <v-spacer></v-spacer>
              <v-btn color="secondary rundown-dialog-btn" @click="purchase">{{$t('PURCHASE_POPUP_SUBSCRIBE')}}</v-btn> 
              <v-btn color="primary rundown-dialog-btn" text @click="show = false">{{$t('PURCHASE_POPUP_CANCEL')}}</v-btn> 
             </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
 import BaseModule from '../BaseModule'
  export default {
    name: 'PurchaseDialog', 
    mixins: [BaseModule],
    props: [],
    data(){
        return {  
             show: false,
             features: []
        }

    },   
    computed: {
        storeProduct() {
        return this.$store.state.rundown.storeProduct;
        }
    },
    methods: {  
        refreshPurchases() {
            window.rundownApp.purchases.refreshPurchases();
            this.$emit('purchase');
            this.show = false;
        }, 
        showPurchaseDialog()
        {  
            this.show = true;
            this.features = this.$t("PURCHASE_POPUP_PREMIUM_FEATURES");
        }, 
        purchase() {
            window.rundownApp.purchases.purchase();
            this.$emit('purchase');
            this.show = false;
        }
      },
  }
</script>
 